const Messages = {
  REQUIRED_MESSAGE: 'This value is required',
  REQUIRED_NAME: 'Please enter name',
  REQUIRED_FIRST_NAME: 'Please enter your first name',
  REQUIRED_MIDDLE_NAME: 'Please enter your middle name',
  REQUIRED_LAST_NAME: 'Please enter your last name',
  REQUIRED_EMAIL: 'Please enter your email',
  REQUIRED_PHONE: 'Please enter your phone number',
  REQUIRED_PASSWORD: 'Please enter your password',
  REQUIRED_CONFIRM_PASSWORD: 'Please confirm your password',
  REQUIRED_CONNECTION_DATE: 'Please choose your preferred connection date',
  REQUIRED_CURRENT_BROADBAND_PROVIDER: 'Please select your current broadband provider',
  REQUIRED_PROVIDER_ACCOUNT_NUMBER: 'Please enter the account number with your current provider',
  INVALID_PROVIDER_ACCOUNT_NUMBER: 'Please enter a valid account number for your current provider',
  REQUIRED_CURRENT_LANDLINE_PROVIDER: 'Please select your current landline provider',
  REQUIRED_ACCEPT_TERMS: 'Please ensure you have read and accepted our Skinny terms and conditions',
  REQUIRED_ADDRESS: 'Please enter address',
  REQUIRED_SUBURB: 'Please enter suburb',
  REQUIRED_CITY: 'Please enter city',
  REQUIRED_POSTCODE: 'Please enter postcode',
  REQUIRED_DOB_DAY: 'Please enter the day of your date of birth',
  REQUIRED_DOB_MONTH: 'Please enter the month of your date of birth',
  REQUIRED_DOB_YEAR: 'Please enter the year of your date of birth',
  REQUIRED_CHOICE: 'Please choose an option',
  REQUIRED_SELECT: 'Please select an option',
  REQUIRED_FIELD: 'This field is required',
  INVALID_NAME: 'Name cannot contain \'<\' or \'>\'',
  INVALID_EMAIL: 'Invalid email address',
  INVALID_PHONE: 'Please enter a valid contact number',
  INVALID_PASSWORD_UPPERCASE: 'Password must contain an uppercase letter',
  INVALID_PASSWORD_NUMBER: 'Password must contain a number',
  INVALID_PASSWORD_LENGTH: 'Password must be at least 8 characters',
  INVALID_PASSWORD_MATCH: 'Passwords must match',
  INVALID_POSTCODE: 'Postcode must only contain numbers',
  REQUIRED_DAY: 'Please enter a day',
  REQUIRED_MONTH: 'Please enter a month',
  REQUIRED_YEAR: 'Please enter a year',
  INVALID_YEARS_AT_ADDRESS: 'Years at address must be between 0 and 150',
  INVALID_MONTHS_AT_ADDRESS: 'Months at address must be between 0 and 12',
  INVALID_DATE: 'Please enter a valid date',
  INVALID_DATE_MUST_BE_PAST: 'Date must be in the past',
  INVALID_DATE_MUST_BE_FUTURE: 'Date must be in the future',
  INVALID_AGE_MUST_BE_OVER: 'Your age must be over ',
  INVALID_NZ_DRIVER_LICENSE_NUMBER: 'Please enter a valid drivers license number',
  INVALID_NZ_PASSPORT_NUMBER: 'Please enter a valid passport number'
};

export default Messages;



/** WEBPACK FOOTER **
 ** ./src/common/validation/Messages.js
 **/